class EnvironmentConfig {
    static get(key: string): string | undefined {
      return process.env[key];
    }
  
    static getOrThrow(key: string): string {
      const value = process.env[key];
      if (value === undefined || value === null) {
        throw new Error(`Environment variable '${key}' not set.`);
      }
      return value;
    }
  
    static getString(key: string, defaultValue: string = ''): string {
      return process.env[key] || defaultValue;
    }
  
    static getInt(key: string, defaultValue: number = 0): number {
      return parseInt(process.env[key] || '', 10) || defaultValue;
    }
  
    static getBool(key: string, defaultValue: boolean = false): boolean {
      const value = process.env[key];
      if (value === 'true') return true;
      if (value === 'false') return false;
      return defaultValue;
    }
  }
  
  export default EnvironmentConfig;